const abrirWhatsApp = (possuiContrato) => {
  const numero = "5517991188943"; // DDD + número (sem + ou traços)
  var mensagem = "";

  if (possuiContrato) {
    mensagem = encodeURIComponent(
      "Olá! Gostaria de mais informações sobre o distrato do meu imóvel."
    );
  } else {
    mensagem = encodeURIComponent(
      "Olá! Não estou com o contrato, mas gostaria de informações sobre o distrato do meu imóvel."
    );
  }

  const url = `https://wa.me/${numero}?text=${mensagem}`;
  window.open(url, "_blank");
};

export default abrirWhatsApp;
